import {loadCompareSubjects, setCompareMethod} from '@explorer/actions/compare';

export const buildCompareActions = storedState => {
  const actions = [];
  if (storedState.compare) {
    actions.push(setCompareMethod(storedState.compare.method));
    actions.push(loadCompareSubjects(storedState.compare.subjects));
  }
  return actions;
};
